import { render, staticRenderFns } from "./FinancialDataForm.vue?vue&type=template&id=38053236&"
import script from "./FinancialDataForm.vue?vue&type=script&lang=ts&"
export * from "./FinancialDataForm.vue?vue&type=script&lang=ts&"
import style0 from "./FinancialDataForm.vue?vue&type=style&index=0&id=38053236&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports